// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1yPeB","delete":"styles_delete__yfGSg","update":"styles_update__X4EdZ","add":"styles_add__ytFTo"};